import { usePrsInfo } from "./effects";

function PrsInfo() {
	const prsInfo = usePrsInfo();
	return (
		<div className='prs-info'>
			<div>{`IP ПС: ${prsInfo.ps_ip}`}</div>
			<div>{`Порт ПС: ${prsInfo.ps_port}`}</div>
			<div>{`Алиас ПРС: ${prsInfo.prs_alias}`}</div>
		</div>
	);
}

export default PrsInfo;
